import ImagePickerButtons from './ImagePickerButtons';
import {
  DEFAULT_BODY_RESULT_OPTIONS,
  getAllowedResultOptions,
  mostSevereStatus,
  readStatusList,
  toggleResultStatus,
} from '../utils/resultOptions';
import { storageUrl } from '../utils/urls';

export default function BodyItemRow({ item, value, onChange, onUpload, onRemoveImage, resultOptions = DEFAULT_BODY_RESULT_OPTIONS }) {
  const allowed = Array.isArray(item?.allowed_result_types) && item.allowed_result_types.length
    ? item.allowed_result_types
    : resultOptions.map((option) => option.value);

  const visibleOptions = getAllowedResultOptions(resultOptions, allowed);

  // يمكن اختيار أكثر من نتيجة للجزء الواحد (مثلاً: خدش + مرشوش).
  const selected = readStatusList(value);

  const toggleStatus = (statusValue) => {
    const normalized = toggleResultStatus(selected, statusValue);
    onChange(item.id, {
      condition_statuses: normalized,
      // أشد الحالات تبقى في الحقل المفرد: عليها يعتمد لون الجزء في الرسم والتقييم.
      condition_status: mostSevereStatus(normalized),
    });
  };

  return (
    <div className="rounded-xl border p-3 bg-white shadow-sm">
      <h4 className="font-bold text-gray-800 mb-2">{item.name}</h4>

      <div className="grid gap-2 md:grid-cols-3">
        {visibleOptions.map((option) => {
          const isOn = selected.includes(option.value);
          return (
            <button
              key={option.value}
              type="button"
              aria-pressed={isOn}
              onClick={() => toggleStatus(option.value)}
              className={`rounded-xl border px-3 py-2 text-sm font-semibold transition ${
                isOn ? 'ring-2 ring-offset-2 ring-slate-900' : 'opacity-60 hover:opacity-100'
              }`}
              style={{
                backgroundColor: option.bgColor,
                borderColor: option.borderColor,
                color: option.textColor,
              }}
            >
              {isOn ? '✓ ' : ''}
              {option.label}
            </button>
          );
        })}
      </div>
      {selected.length > 1 && (
        <p className="mt-2 text-xs text-slate-500">
          تم اختيار {selected.length} نتائج — لون الجزء في الرسم يتبع الأشد.
        </p>
      )}

      <div className="mt-3 grid gap-2 md:grid-cols-[1fr_auto_auto] md:items-center">
        <input
          type="text"
          value={value?.notes || ''}
          placeholder="ملاحظة..."
          onChange={(e) => onChange(item.id, { notes: e.target.value })}
          className="w-full rounded-lg border p-2"
        />
        {value?.attachment?.file_path && (
          <div className="relative h-14 w-14 overflow-hidden rounded-lg border bg-slate-100">
            <img src={storageUrl(value.attachment.file_path)} alt="" className="h-full w-full object-cover" />
            <button
              type="button"
              onClick={() => onRemoveImage?.(item.id, value.attachment)}
              className="absolute right-1 top-1 flex h-5 w-5 items-center justify-center rounded-full bg-black/70 text-xs font-bold leading-none text-white"
              aria-label="Remove image"
            >
              ×
            </button>
          </div>
        )}
        <ImagePickerButtons onSelect={(file) => onUpload(item.id, file)} />
      </div>
    </div>
  );
}
